import { SubscriptionProduct, TimeInterval } from 'root-constants'

export const TRIAL_PERIOD_TO_INTERVAL_MAP: Record<
  number,
  { interval: TimeInterval; count: number }
> = {
  [SubscriptionProduct.THREE_DAY]: { interval: TimeInterval.DAY, count: 3 },
  [SubscriptionProduct.SEVEN_DAY]: { interval: TimeInterval.DAY, count: 7 },
  [SubscriptionProduct.ONE_MONTH]: { interval: TimeInterval.MONTH, count: 1 },
  [SubscriptionProduct.THREE_MONTHS]: {
    interval: TimeInterval.MONTH,
    count: 3,
  },
  [SubscriptionProduct.SIX_MONTHS]: { interval: TimeInterval.MONTH, count: 6 },
  364: { interval: TimeInterval.WEEK, count: 52 },
  365: { interval: TimeInterval.WEEK, count: 52 },
}

export const TRIAL_PERIOD_KEY_MAP = {
  [TimeInterval.DAY]: 'purchaseLongV3.trialDayInterval',
  [TimeInterval.WEEK]: 'purchaseLongV3.trialWeekInterval',
  [TimeInterval.MONTH]: 'purchaseLongV3.trialMonthInterval',
  [TimeInterval.YEAR]: 'purchaseLongV3.trialYearInterval',
} as const satisfies Record<TimeInterval, string>

export const RECURRING_PERIOD_TO_INTERVAL_MAP: Record<
  number,
  { interval: TimeInterval; count: number }
> = {
  7: { interval: TimeInterval.WEEK, count: 1 },
  14: { interval: TimeInterval.WEEK, count: 2 },
  28: { interval: TimeInterval.WEEK, count: 4 },
  30: { interval: TimeInterval.WEEK, count: 4 },
  84: { interval: TimeInterval.WEEK, count: 12 },
  90: { interval: TimeInterval.WEEK, count: 12 },
  364: { interval: TimeInterval.WEEK, count: 52 },
  365: { interval: TimeInterval.WEEK, count: 52 },
}

export const RECURRING_PERIOD_KEY_MAP = {
  [TimeInterval.DAY]: 'purchaseLongV3.everyDayInterval',
  [TimeInterval.WEEK]: 'purchaseLongV3.everyWeekInterval',
  [TimeInterval.MONTH]: 'purchaseLongV3.everyMonthInterval',
  [TimeInterval.YEAR]: 'purchaseLongV3.everyYearInterval',
} as const satisfies Record<TimeInterval, string>
